import { EVENT_STATUS_LABELS, EventStatus } from '@peles/shared';

/** `StatusBadge` colour per event status — one table for every screen. */
export const EVENT_STATUS_COLORS: Record<EventStatus, string> = {
  [EventStatus.DRAFT]: 'gray',
  [EventStatus.PLANNING]: 'blue',
  [EventStatus.CONFIRMED]: 'green',
  [EventStatus.IN_PROGRESS]: 'yellow',
  [EventStatus.COMPLETED]: 'purple',
  [EventStatus.CANCELLED]: 'red',
};

/** Statuses in their natural order, for pickers, filters and board columns. */
export const EVENT_STATUS_OPTIONS = (Object.keys(EVENT_STATUS_LABELS) as EventStatus[]).map(
  (value) => ({ id: value, name: EVENT_STATUS_LABELS[value] }),
);

export function eventStatusLabel(status: string): string {
  return EVENT_STATUS_LABELS[status as EventStatus] ?? status;
}

export function eventStatusColor(status: string): string {
  return EVENT_STATUS_COLORS[status as EventStatus] ?? 'gray';
}
